import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";
import type { ComponentType } from "@repo/editor/types";
import * as t from "@rekajs/types";
import { forwardRef } from "react";

export const ReviewHeaderDefinition: ComponentSettingsProps = {
  title: {
    type: "html",
    label: "Title",
    default: "<h2>Review Header</h2>",
  },
  description: {
    type: "html",
    label: "Description",
    default: "<p>Review Header</p>",
  },
  image: {
    type: "image",
    label: "Image",
  },
  alt: {
    type: "string",
    label: "Alt",
    default: "Review Header",
  },
};

interface ReviewHeaderProps {
  title: string;
  description: string;
  image: string;
  alt: string;
}

export const ReviewHeader = forwardRef<HTMLDivElement, ReviewHeaderProps>(
  (props, ref) => {
    return (
      <div
        className="w-full h-full grid grid-cols-1 lg:grid-cols-12 gap-x-24 gap-y-5"
        ref={ref}
      >
        <div className="lg:col-span-2">
          <img alt={props.alt} src={props.image} />
        </div>
        <div className="col-span-1 lg:col-span-10 flex flex-col gap-y-5">
          <div
            className="rtl:font-doran font-helvetica rtl:font-bold text-[18px] md:text-[30px] lg:text-[45px] font-[100] uppercase leading-[1.49] tracking-[0.45px] text-justify text-[#f70] ql-editor"
            dangerouslySetInnerHTML={{
              __html:
                props.title || String(ReviewHeaderDefinition.title.default),
            }}
          />
          <div
            className="rtl:font-doran font-helvetica rtl:font-normal text-[15px] md:text-[19px] lg:text-[22px] font-light leading-[1.27] tracking-[0.01px] text-[#929292] ql-editor"
            dangerouslySetInnerHTML={{
              __html:
                props.description ||
                String(ReviewHeaderDefinition.description.default),
            }}
          />
        </div>
      </div>
    );
  }
) as ComponentType<ReviewHeaderProps>;
ReviewHeader.displayName = "ReviewHeader";

export const ReviewHeaderSettings: ComponentSettings = {
  name: "EReviewHeader",
  props: ReviewHeaderDefinition,
  label: "هدر نظرات",
  widgets: {
    label: "هدر نظرات",
    template: () =>
      t.componentTemplate({
        component: t.identifier({ name: "EReviewHeader", external: true }),
      }),
  },
};

ReviewHeader.componentSettings = ReviewHeaderSettings;
